import React from 'react';
import { AuthSilentCallback } from '@klpkonsern/auth-core/routes';
import { Main } from '@klp/layout/Main';
import { Typography } from '@klp/design/Typography';

export const SilentCallbackView: React.FC = () => {
    return (
        <AuthSilentCallback>
            <Main withoutHeader={true} withoutSidebar={true} centered={true}>
                <Typography
                    klpHeadingLevel="ONE"
                    translation="auth.authorizing"
                />
            </Main>
        </AuthSilentCallback>
    );
};
